import { useState } from 'react';
import { Box, Icon, Row, Text } from '~/commonComponents';
import { CopyIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';

interface IReferralLinkProps {
  link: string;
  style?: React.CSSProperties;
}

export const ReferralLink = ({ link, style }: IReferralLinkProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setIsCopied(true);
  };

  return (
    <Box style={style}>
      <Text
        bold
        color="neutral_600"
        marginLeft={4}
        marginBottom={-4}
      >
        Copy and Share Your Link
      </Text>
      <Row gap={20} paddingTop={16}>
        <input
          className="input-field"
          style={{ margin: 0, width: '380px', borderRadius: 10 }}
          type="text"
          value={link}
          disabled={true}
        />

        <button
          type="button"
          className="button"
          style={{
            backgroundColor: Colors.primary_500,
            alignItems: 'center',
            display: 'flex',
            alignSelf: 'center',
            margin: 0,
            paddingBlock: 3,
          }}
          onClick={() => {
            handleCopy();
          }}
        >
          <CopyIcon />
          <Text bold fontSize={16} color="white" marginLeft={5}>
            Copy
          </Text>
        </button>
      </Row>
      <Row gap={4} alignItems="center" height={32} marginLeft={2}>
        {isCopied && (
          <>
            <Icon name="check" size={24} />
            <Text>
              Your referral link has been <Text bold>copied</Text>!
            </Text>
          </>
        )}
      </Row>
    </Box>
  );
};
